import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useMutation, useQueryClient } from 'react-query';

function useManageTopicNotes({ topicID }) {
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;
  const queryClient = useQueryClient();

  function addTopicNotes(data = {}) {
    return privateFetch.post(`/v1/admin/topic/${topicID}/notes`, data);
  }

  function updateTopicNotes(data = {}) {
    return privateFetch.put(`/v1/admin/topic/${topicID}/notes`, data);
  }

  function deleteTopicNote({ noteID } = {}) {
    return privateFetch.delete(`/v1/admin/topic/${topicID}/notes/${noteID}`);
  }

  function reOrderTopicNotes(data = {}) {
    return privateFetch.patch(`/v1/admin/content/note/reorder`, data);
  }

  function manageTopicsSections({ type, ...data } = {}) {
    if (type === 'UPDATE') {
      return updateTopicNotes(data);
    }

    if (type === 'DELETE') {
      return deleteTopicNote(data);
    }

    if (type === 'REORDER') {
      return reOrderTopicNotes(data);
    }

    return addTopicNotes(data);
  }

  return useMutation(manageTopicsSections, {
    onSuccess() {},
    onError() {},
    onSettled() {
      queryClient.invalidateQueries('topic-details');
    },
  });
}

export default useManageTopicNotes;
